import { cn } from "@/lib/utils";

// Dynamic rundown status from event date + start/end time vs current time (local/WIB).
// Returns 'PREPARE' | 'ON GOING' | 'DONE', or null when data is incomplete.
export function rundownStatus(ev, item, now) {
  const dstr = String(ev?.wedding_date || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dstr) || !item?.time || !item?.end_time) return null;
  const [Y, M, D] = dstr.split("-").map(Number);
  const sp = String(item.time).split(":").map(Number);
  const ep = String(item.end_time).split(":").map(Number);
  if (sp.length < 2 || ep.length < 2 || [Y, M, D, sp[0], sp[1], ep[0], ep[1]].some(Number.isNaN)) return null;
  const start = new Date(Y, M - 1, D, sp[0], sp[1], 0);
  let end = new Date(Y, M - 1, D, ep[0], ep[1], 0);
  if (end <= start) end = new Date(Y, M - 1, D + 1, ep[0], ep[1], 0);
  const t = now || new Date();
  if (t < start) return "PREPARE";
  if (t < end) return "ON GOING";
  return "DONE";
}

const STYLES = {
  "PREPARE": "bg-amber-100 text-amber-700",
  "ON GOING": "bg-burgundy text-white animate-pulse",
  "DONE": "bg-emerald-100 text-emerald-700",
};

export const RundownBadge = ({ status, className }) => (
  <span className={cn("inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap", STYLES[status] || "bg-beige text-burgundy", className)} data-testid="rundown-auto-status">{status}</span>
);
